import axiosIns from '@/libs/axios'

export default class DescriptionApis {
    get = async data => await axiosIns.get('description', { params: data })
}
